import React from 'react';
import { ChartPreviewType } from '../types/DashboardLayoutTypes';

type Props = {
	type: ChartPreviewType;
	size?: number;
};

const C1 = '#1781A1';
const C2 = '#16E0CC';
const C3 = '#e8a824';
const BG = '#f0f4f5';

const DonutPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<circle cx="24" cy="24" r="16" fill="none" stroke={BG} strokeWidth="7" />
		<circle cx="24" cy="24" r="16" fill="none" stroke={C1} strokeWidth="7"
			strokeDasharray="60 100" strokeDashoffset="0" strokeLinecap="round" />
		<circle cx="24" cy="24" r="16" fill="none" stroke={C2} strokeWidth="7"
			strokeDasharray="25 100" strokeDashoffset="-60" strokeLinecap="round" />
		<circle cx="24" cy="24" r="16" fill="none" stroke={C3} strokeWidth="7"
			strokeDasharray="15 100" strokeDashoffset="-85" strokeLinecap="round" />
	</svg>
);

const BarPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="6" y="28" width="7" height="14" rx="2" fill={C2} opacity="0.7" />
		<rect x="16" y="18" width="7" height="24" rx="2" fill={C1} />
		<rect x="26" y="10" width="7" height="32" rx="2" fill={C1} opacity="0.8" />
		<rect x="36" y="22" width="7" height="20" rx="2" fill={C2} opacity="0.6" />
	</svg>
);

const HBarPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="6" y="7" width="36" height="6" rx="2" fill={C1} />
		<rect x="6" y="16" width="28" height="6" rx="2" fill={C1} opacity="0.75" />
		<rect x="6" y="25" width="20" height="6" rx="2" fill={C2} />
		<rect x="6" y="34" width="14" height="6" rx="2" fill={C2} opacity="0.6" />
	</svg>
);

const LinePreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<polyline points="6,36 14,28 22,32 30,18 38,22 44,12" fill="none" stroke={C1} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
		<polyline points="6,38 14,34 22,36 30,28 38,30 44,24" fill="none" stroke={C2} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
		<line x1="6" y1="42" x2="44" y2="42" stroke={BG} strokeWidth="1" />
	</svg>
);

// Variante "combustão": linha + gota de combustível no canto superior esquerdo.
const LineFuelPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<polyline points="6,36 14,28 22,32 30,18 38,22 44,12" fill="none" stroke={C1} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
		<polyline points="6,38 14,34 22,36 30,28 38,30 44,24" fill="none" stroke={C2} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
		<line x1="6" y1="42" x2="44" y2="42" stroke={BG} strokeWidth="1" />
		<path d="M9 2 C9 2 4 8 4 12 a5 5 0 1 0 10 0 C14 8 9 2 9 2 Z" fill={C3} />
	</svg>
);

// Variante "elétrico": linha + raio no canto superior esquerdo.
const LineElectricPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<polyline points="6,36 14,28 22,32 30,18 38,22 44,12" fill="none" stroke={C1} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
		<polyline points="6,38 14,34 22,36 30,28 38,30 44,24" fill="none" stroke={C2} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
		<line x1="6" y1="42" x2="44" y2="42" stroke={BG} strokeWidth="1" />
		<path d="M11 2 L4 14 L8 14 L6 20 L14 9 L10 9 L13 2 Z" fill="#FACC15" stroke="#B45309" strokeWidth="0.5" strokeLinejoin="round" />
	</svg>
);

const KpiPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="3" y="12" width="13" height="24" rx="3" fill={C1} opacity="0.15" />
		<text x="9.5" y="27" textAnchor="middle" fontSize="10" fontWeight="bold" fill={C1}>12</text>
		<rect x="18" y="12" width="13" height="24" rx="3" fill={C3} opacity="0.15" />
		<text x="24.5" y="27" textAnchor="middle" fontSize="10" fontWeight="bold" fill={C3}>3</text>
		<rect x="33" y="12" width="13" height="24" rx="3" fill={C2} opacity="0.15" />
		<text x="39.5" y="27" textAnchor="middle" fontSize="9" fontWeight="bold" fill="#2dbc6e">87%</text>
	</svg>
);

const TablePreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="5" y="10" width="38" height="4" rx="1" fill={C1} opacity="0.8" />
		<rect x="5" y="18" width="38" height="3" rx="1" fill={BG} />
		<rect x="5" y="24" width="38" height="3" rx="1" fill={BG} />
		<rect x="5" y="30" width="38" height="3" rx="1" fill={BG} />
		<rect x="5" y="36" width="38" height="3" rx="1" fill={BG} />
		<rect x="5" y="18" width="12" height="3" rx="1" fill={C1} opacity="0.65" />
		<rect x="5" y="24" width="18" height="3" rx="1" fill={C1} opacity="0.55" />
		<rect x="5" y="30" width="10" height="3" rx="1" fill={C1} opacity="0.65" />
		<rect x="5" y="36" width="15" height="3" rx="1" fill={C1} opacity="0.55" />
	</svg>
);

const ProgressPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="5" y="10" width="38" height="3.5" rx="1.75" fill={BG} />
		<rect x="5" y="10" width="36" height="3.5" rx="1.75" fill={C1} />
		<rect x="5" y="17" width="38" height="3.5" rx="1.75" fill={BG} />
		<rect x="5" y="17" width="26" height="3.5" rx="1.75" fill={C2} />
		<rect x="5" y="24" width="38" height="3.5" rx="1.75" fill={BG} />
		<rect x="5" y="24" width="18" height="3.5" rx="1.75" fill={C3} />
		<rect x="5" y="31" width="38" height="3.5" rx="1.75" fill={BG} />
		<rect x="5" y="31" width="12" height="3.5" rx="1.75" fill={C1} opacity="0.6" />
	</svg>
);

const MapPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="4" y="8" width="40" height="32" rx="4" fill="#e4f0ec" />
		<line x1="4" y1="24" x2="44" y2="24" stroke="#fff" strokeWidth="2" />
		<line x1="20" y1="8" x2="20" y2="40" stroke="#fff" strokeWidth="2" />
		<circle cx="16" cy="20" r="3.5" fill={C1} />
		<circle cx="16" cy="20" r="1.5" fill="#fff" />
		<circle cx="32" cy="28" r="3.5" fill={C1} />
		<circle cx="32" cy="28" r="1.5" fill="#fff" />
	</svg>
);

const StackedPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="6" y="22" width="7" height="20" rx="2" fill={C1} />
		<rect x="6" y="22" width="7" height="8" rx="2" fill={C3} />
		<rect x="16" y="14" width="7" height="28" rx="2" fill={C1} />
		<rect x="16" y="14" width="7" height="12" rx="2" fill={C3} />
		<rect x="26" y="18" width="7" height="24" rx="2" fill={C1} />
		<rect x="26" y="18" width="7" height="10" rx="2" fill={C3} />
		<rect x="36" y="10" width="7" height="32" rx="2" fill={C1} />
		<rect x="36" y="10" width="7" height="14" rx="2" fill={C3} />
	</svg>
);

const SplitBarPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="4" y="18" width="40" height="12" rx="3" fill={BG} />
		<rect x="4" y="18" width="22" height="12" rx="3" fill={C2} />
		<rect x="26" y="18" width="18" height="12" rx="0 3 3 0" fill={C1} opacity="0.4" />
	</svg>
);

const ComparePreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		{/* Row 1: barra XXX barra */}
		<rect x="2" y="8" width="14" height="4" rx="1.5" fill={C1} />
		<text x="24" y="12" textAnchor="middle" fontSize="5" fill="#9ca3af" fontFamily="Roboto">XXX</text>
		<rect x="32" y="8" width="14" height="4" rx="1.5" fill={C2} />
		{/* Row 2: barra YYY barra */}
		<rect x="2" y="21" width="14" height="4" rx="1.5" fill={C1} />
		<text x="24" y="25" textAnchor="middle" fontSize="5" fill="#9ca3af" fontFamily="Roboto">YYY</text>
		<rect x="32" y="21" width="14" height="4" rx="1.5" fill={C2} />
		{/* Row 3: barra ZZZ barra */}
		<rect x="2" y="34" width="14" height="4" rx="1.5" fill={C1} />
		<text x="24" y="38" textAnchor="middle" fontSize="5" fill="#9ca3af" fontFamily="Roboto">ZZZ</text>
		<rect x="32" y="34" width="14" height="4" rx="1.5" fill={C2} />
	</svg>
);

const StackedDualPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<path d="M4,38 L12,28 L20,24 L28,26 L36,30 L44,32 L44,42 L4,42 Z" fill={C2} opacity="0.4" />
		<path d="M4,30 L12,18 L20,14 L28,16 L36,22 L44,24 L44,32 L36,30 L28,26 L20,24 L12,28 L4,38 Z" fill={C1} opacity="0.35" />
		<polyline points="4,30 12,18 20,14 28,16 36,22 44,24" fill="none" stroke={C1} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<polyline points="4,38 12,28 20,24 28,26 36,30 44,32" fill="none" stroke={C2} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.7" />
		<line x1="4" y1="42" x2="44" y2="42" stroke={BG} strokeWidth="1" />
	</svg>
);

const CalendarPreview = ({ s }: { s: number }) => (
	<svg width={s} height={s} viewBox="0 0 48 48">
		<rect x="6" y="10" width="36" height="30" rx="3" fill="#fff" stroke={BG} strokeWidth="1.5" />
		<rect x="6" y="10" width="36" height="8" rx="3" fill={C1} opacity="0.7" />
		<rect x="12" y="22" width="4" height="4" rx="1" fill={BG} />
		<rect x="22" y="22" width="4" height="4" rx="1" fill={C1} />
		<rect x="32" y="22" width="4" height="4" rx="1" fill={BG} />
		<rect x="12" y="30" width="4" height="4" rx="1" fill={BG} />
		<rect x="22" y="30" width="4" height="4" rx="1" fill={BG} />
		<rect x="32" y="30" width="4" height="4" rx="1" fill={C3} />
	</svg>
);

const PREVIEWS: Record<ChartPreviewType, React.FC<{ s: number }>> = {
	donut: DonutPreview,
	bar: BarPreview,
	hbar: HBarPreview,
	line: LinePreview,
	lineFuel: LineFuelPreview,
	lineElectric: LineElectricPreview,
	kpi: KpiPreview,
	table: TablePreview,
	progress: ProgressPreview,
	map: MapPreview,
	stacked: StackedPreview,
	splitbar: SplitBarPreview,
	compare: ComparePreview,
	stackedDual: StackedDualPreview,
	calendar: CalendarPreview,
};

const ChartPreviewIcon = ({ type, size = 48 }: Props) => {
	const Preview = PREVIEWS[type] || BarPreview;
	return <Preview s={size} />;
};

export default ChartPreviewIcon;
